var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviousTripIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_401_29322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5273 7.5V12H17.0273M12.5273 22.5C11.1341 22.5 10.4375 22.5 9.85261 22.423C5.81401 21.8913 2.63603 18.7133 2.10434 14.6747C2.02734 14.0899 2.02734 13.3933 2.02734 12C2.02734 10.6067 2.02734 9.91011 2.10434 9.32526C2.63603 5.28666 5.81401 2.10869 9.85261 1.577C10.4375 1.5 11.1341 1.5 12.5273 1.5C13.9206 1.5 14.6172 1.5 15.2021 1.577C19.2407 2.10869 22.4187 5.28666 22.9503 9.32526C23.0273 9.91011 23.0273 10.6067 23.0273 12C23.0273 13.3933 23.0273 14.0899 22.9503 14.6747C22.4187 18.7133 19.2407 21.8913 15.2021 22.423C14.6172 22.5 13.9206 22.5 12.5273 22.5Z",
    stroke: "#535353",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_401_29322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.527344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousTripIcon);
export default __webpack_public_path__ + "static/media/previousTripIcon.e8ebf2d7b3565a53ebe5249c78537060.svg";
export { ForwardRef as ReactComponent };